/* eslint-disable import/no-anonymous-default-export */
import { cloneDeep } from "lodash";
import React, { useState } from "react";
import colors from "../../config/colors";
import { RiBankFill, RiPhoneFill } from "react-icons/ri";
import { MdEmail } from "react-icons/md";
import { IoLocationSharp, IoPersonCircle } from "react-icons/io5";
import { IoIosMail } from "react-icons/io";
import { BiPlus } from "react-icons/bi";
import { AiFillTag } from "react-icons/ai";
import AppInput from "../../common/AppInput";
import AppButton from "../../common/AppButton";
import LabelText from "../../common/LabelText";
import validation from "../../common/validation";
import api from "../../config/api";
import focusInputByName from "../../common/focusInputByName";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";

const size = 25;
const formInit = {
  name: "",
  careOf: "",
  phone: "",
  email: "",
  billingAddress: "",
  locations: [
    {
      title: "",
      tag: "",
      incharge: "",
      contact: "",
    },
  ],
};

export default function OrganizationCreateModel() {
  const queryClient = useQueryClient();

  const Body = ({ onDone }) => {
    const [disabled, setDisabled] = useState(false);
    const [form, setForm] = useState(cloneDeep(formInit));
    const newLocation = () => {
      setForm({
        ...form,
        locations: [...form.locations, cloneDeep(formInit.locations[0])],
      });
    };

    const handleLocationChange = ({ target }, ind) => {
      const value = target.value;
      const name = target.name;
      const locations = [...form.locations];
      locations[ind][name] = value;
      setForm({ ...form, locations });
    };

    const handleChange = ({ target }) => {
      const name = target.name;
      const value = target.value;
      setDisabled(false);
      setForm({ ...form, [name]: value });
    };

    const handleSubmit = async (event) => {
      setDisabled(true);
      event.preventDefault();
      if (
        !validation({
          data: form,
          except: ["careOf"],
        })
      )
        return false;

      const locations = form.locations.filter((i) => i.tag);
      if (locations.length === 0) {
        return focusInputByName("incharge");
      } else {
        if (!locations[0].incharge) return focusInputByName("incharge");
        if (!locations[0].title) return focusInputByName("title");
      }

      const res = await api.post("organizations", {
        ...form,
        locations,
      });
      if (!res.ok) {
        setDisabled(true);
        return toast.error(res.originalError.message);
      }
      queryClient.invalidateQueries(["organizations"]);

      toast.success("Task has been succesfully marked completed.");

      setDisabled(true);
      setForm(cloneDeep(formInit));
      onDone && onDone();
    };

    return (
      <React.Fragment>
        <Modal.Header closeButton>
          <span className="d-flex" style={{ alignItems: "center" }}>
            <b>New Client</b>
          </span>
        </Modal.Header>
        <Modal.Body style={{ overflowY: "scroll" }}>
          <form id="form" onSubmit={handleSubmit}>
            <div
              className="d-flex"
              style={{
                flexDirection: "column",
                gap: "20px",
                padding: "0px 30px 20px 30px",
                overflowY: "auto",
              }}
            >
              <div className="d-flex" style={{ gap: 20 }}>
                <AppInput
                  label="Name"
                  autoFocus
                  name="name"
                  onChange={handleChange}
                  leftIcon={<RiBankFill size={size} color={colors.silver} />}
                  floatLabel
                  value={form.name}
                  inputType="text"
                  required
                />
                <AppInput
                  label="Care Of"
                  floatLabel
                  name="careOf"
                  value={form.careOf}
                  onChange={handleChange}
                  leftIcon={
                    <IoLocationSharp size={size} color={colors.silver} />
                  }
                />
              </div>

              <div className="d-flex" style={{ gap: 20 }}>
                <AppInput
                  label="Phone"
                  floatLabel
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  required
                  inputType="tel"
                  leftIcon={<RiPhoneFill size={size} color={colors.silver} />}
                />
                <AppInput
                  label="Email"
                  floatLabel
                  name="email"
                  inputType="email"
                  required
                  value={form.email}
                  onChange={handleChange}
                  leftIcon={<MdEmail size={size} color={colors.silver} />}
                />
              </div>
              <div className="d-flex" style={{ gap: 20 }}>
                <AppInput
                  label="Billing Address"
                  floatLabel
                  name="billingAddress"
                  value={form.billingAddress}
                  onChange={handleChange}
                  required
                  leftIcon={
                    <IoLocationSharp size={size} color={colors.silver} />
                  }
                />
              </div>

              <LabelText label="Locations" />
              {form.locations.length === 1 && (
                <div
                  style={{
                    border: "1px solid #77777720",
                    padding: 10,
                    borderRadius: 3,
                  }}
                >
                  <div className="d-flex" style={{ gap: 20 }}>
                    <AppInput
                      label="Administrator"
                      floatLabel
                      name="incharge"
                      leftIcon={
                        <IoPersonCircle size={size} color={colors.silver} />
                      }
                      onChange={(event) => {
                        handleLocationChange(event, 0);
                      }}
                      value={form.locations[0].incharge}
                    />
                    <AppInput
                      label="Designation"
                      floatLabel
                      name="tag"
                      leftIcon={<AiFillTag size={size} color={colors.silver} />}
                      onChange={(event) => {
                        handleLocationChange(event, 0);
                      }}
                      value={form.locations[0].tag}
                    />

                    <AppInput
                      label="Contact"
                      floatLabel
                      name="contact"
                      leftIcon={<IoIosMail size={size} color={colors.silver} />}
                      onChange={(event) => {
                        handleLocationChange(event, 0);
                      }}
                      value={form.locations[0].contact}
                    />
                  </div>
                  <AppInput
                    label="Location"
                    floatLabel
                    name="title"
                    onChange={(event) => {
                      handleLocationChange(event, 0);
                    }}
                    value={form.locations[0].title}
                    leftIcon={
                      <IoLocationSharp size={size} color={colors.silver} />
                    }
                    rightIcon={<BiPlus size={size} color={colors.silver} />}
                    onClickRight={newLocation}
                  />
                </div>
              )}
              <div>
                {form.locations.length > 1 &&
                  form.locations.map((loc, ind) => {
                    const last = ind + 1 === form.locations.length;
                    return (
                      <div
                        key={String(ind)}
                        style={{
                          border: "1px solid #77777720",
                          padding: 10,
                          borderRadius: 3,
                          marginBottom: 5,
                        }}
                      >
                        <div>
                          <div className="d-flex" style={{ gap: 20 }}>
                            <AppInput
                              label="Administrator"
                              floatLabel
                              name="incharge"
                              leftIcon={
                                <IoPersonCircle
                                  size={size}
                                  color={colors.silver}
                                />
                              }
                              onChange={(event) => {
                                handleLocationChange(event, ind);
                              }}
                              value={loc.incharge}
                            />
                            <AppInput
                              autoFocus
                              label="Designt"
                              floatLabel
                              name="tag"
                              leftIcon={
                                <AiFillTag size={size} color={colors.silver} />
                              }
                              onChange={(event) => {
                                handleLocationChange(event, ind);
                              }}
                              value={loc.tag}
                            />

                            <AppInput
                              label="Contact"
                              floatLabel
                              name="contact"
                              leftIcon={
                                <IoIosMail size={size} color={colors.silver} />
                              }
                              onChange={(event) => {
                                handleLocationChange(event, ind);
                              }}
                              value={loc.contact}
                            />
                          </div>
                        </div>
                        <AppInput
                          label="Location"
                          floatLabel
                          name="title"
                          onChange={(event) => {
                            handleLocationChange(event, ind);
                          }}
                          value={loc.title}
                          leftIcon={
                            <IoLocationSharp
                              size={size}
                              color={colors.silver}
                            />
                          }
                          rightIcon={
                            last && <BiPlus size={size} color={colors.silver} />
                          }
                          onClickRight={newLocation}
                        />
                      </div>
                    );
                  })}
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <AppButton
            disabled={disabled}
            text="Create"
            form="form"
            type="submit"
            className="text-primary btn-light"
          />
        </Modal.Footer>
      </React.Fragment>
    );
  };

  return { Body };
}
